import { toast } from "react-toastify";
import * as Api from "../../Api/Api";
import * as actionTypes from "../actions/actionTypes";

//ledger reports
const getLedgerReportsStart = () => {
  return {
    type: actionTypes.GET_LEDGER_REPORTS_START,
  };
};

const getLedgerReportsSuccess = (data) => {
  return {
    type: actionTypes.GET_LEDGER_REPORTS_SUCCESS,
    data,
  };
};

const getLedgerReportsFail = (err) => {
  return {
    type: actionTypes.GET_LEDGER_REPORTS_FAIL,
    err,
  };
};

export const resetLedgerReports = () => {
  return {
    type: actionTypes.RESET_LEDGER_REPORTS_START,
  };
};

export const getLedgerReports = (date) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }
  return async (dispatch) => {
    dispatch(getLedgerReportsStart());

    try {
      let res = "";
      if (sessionStorage.getItem("userId")) {
        res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "/api/report/LedgerReport"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: sessionStorage.getItem("userId"),
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata.data.errorCode === "200") {
          dispatch(getLedgerReportsSuccess(finaldata.data));
        } else if (finaldata.data.errorCode === "404") {
          dispatch(getLedgerReportsFail({ error: "Data not found!" }));
        } else {
          dispatch(getLedgerReportsFail({ error: "Some error occurred!" }));
          toast.error("Some error occurred in fetching ledger report!");
        }
      }
    } catch (err) {
      dispatch(getLedgerReportsFail(err.message));
    }
  };
};

//DMT reports
const getDMTReportsStart = () => {
  return {
    type: actionTypes.GET_DMT_REPORTS_START,
  };
};

const getDMTReportsSuccess = (data) => {
  return {
    type: actionTypes.GET_DMT_REPORTS_SUCCESS,
    data,
  };
};

const getDMTReportsFail = (err) => {
  return {
    type: actionTypes.GET_DMT_REPORTS_FAIL,
    err,
  };
};

export const getDMTReports = (date, url) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }

  return async (dispatch) => {
    dispatch(getDMTReportsStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${process.env.REACT_APP_SITE_PRODUCTION_URL + url}`,
        "application/x-www-form-urlencoded",
        {
          UserId: sessionStorage.getItem("userId"),
          ...DateObj,
        }
      );

      const finaldata = await res;

      if (finaldata) {
        if (finaldata.data) {
          if (finaldata.data.errorCode === "200") {
            dispatch(getDMTReportsSuccess(finaldata.data));
          } else if (finaldata.data.errorCode === "404") {
            dispatch(getDMTReportsFail({ error: "Data not found!" }));
          } else {
            dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } else {
        dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
      }
    } catch (e) {
      dispatch(getDMTReportsFail(e));
    }
  };
};
export const getReportById = (date, url, id) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }

  return async (dispatch) => {
    dispatch(getDMTReportsStart());
    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${process.env.REACT_APP_SITE_PRODUCTION_URL + url}`,
        "application/x-www-form-urlencoded",
        {
          UserId: id,
          ...DateObj,
        }
      );

      const finaldata = await res;

      if (finaldata) {
        if (finaldata.data) {
          if (finaldata.data.errorCode === "200") {
            dispatch(getDMTReportsSuccess(finaldata.data));
          } else if (finaldata.data.errorCode === "404") {
            dispatch(getDMTReportsFail({ error: "Data not found!" }));
          } else {
            dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } else {
        dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
      }
    } catch (e) {
      dispatch(getDMTReportsFail(e));
    }
  };
};

//ReceiveTopUp reports
const getReceiveTopUpReportsStart = () => {
  return {
    type: actionTypes.GET_RECEIVE_TOP_UP_REPORTS_START,
  };
};

const getReceiveTopUpReportsSuccess = (data) => {
  return {
    type: actionTypes.GET_RECEIVE_TOP_UP_REPORTS_SUCCESS,
    data,
  };
};

const getReceiveTopUpReportsFail = (err) => {
  return {
    type: actionTypes.GET_RECEIVE_TOP_UP_REPORTS_FAIL,
    err,
  };
};

export const getReceiveTopUpReports = (date) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }
  return async (dispatch) => {
    dispatch(getReceiveTopUpReportsStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL +
          "/api/report/receivedTopUpReport"
        }`,
        "application/x-www-form-urlencoded",
        {
          UserId: sessionStorage.getItem("userId"),
          ...DateObj,
        }
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(getReceiveTopUpReportsSuccess(finaldata.data));
      } else if (finaldata.data.errorCode === "404") {
        dispatch(getReceiveTopUpReportsFail({ error: "Data not found!" }));
      }
    } catch (e) {
      dispatch(getReceiveTopUpReportsFail(e));
    }
  };
};

//Wallet load reports
const getWalletLoadReportStart = () => {
  return {
    type: actionTypes.GET_WALLET_LOAD_REPORTS_START,
  };
};

const getWalletLoadReportSuccess = (data) => {
  return {
    type: actionTypes.GET_WALLET_LOAD_REPORTS_SUCCESS,
    data,
  };
};

const getWalletLoadReportFail = (err) => {
  return {
    type: actionTypes.GET_WALLET_LOAD_REPORTS_FAIL,
    err,
  };
};

export const getWalletLoadReport = (date) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }
  return async (dispatch) => {
    dispatch(getWalletLoadReportStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL +
          "/api/report/walletLoadReport"
        }`,
        "application/x-www-form-urlencoded",
        {
          UserId: sessionStorage.getItem("userId"),
          ...DateObj,
        }
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(getWalletLoadReportSuccess(finaldata.data));
      } else if (finaldata.data.errorCode === "404") {
        dispatch(getWalletLoadReportFail({ error: "Data not found!" }));
      }
    } catch (e) {
      dispatch(getWalletLoadReportFail(e));
    }
  };
};
export const getDistRetWalletLoadReport = (date, id) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }
  return async (dispatch) => {
    dispatch(getWalletLoadReportStart());
    if (id === "0") {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "/api/report/DistWallertLoadReport"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: sessionStorage.getItem("userId"),
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata.data.errorCode === "200") {
          dispatch(getWalletLoadReportSuccess(finaldata.data));
        } else if (finaldata.data.errorCode === "404") {
          dispatch(getWalletLoadReportFail({ error: "Data not found!" }));
        }
      } catch (e) {
        dispatch(getWalletLoadReportFail(e));
      }
    } else {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "/api/report/DistWallertLoadReport"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: id,
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata.data.errorCode === "200") {
          dispatch(getWalletLoadReportSuccess(finaldata.data));
        } else if (finaldata.data.errorCode === "404") {
          dispatch(getWalletLoadReportFail({ error: "Data not found!" }));
        }
      } catch (e) {
        dispatch(getWalletLoadReportFail(e));
      }
    }
  };
};
export const getDistRetWalletLoadReportV2 = (date, id) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }

  return async (dispatch) => {
    dispatch(getDMTReportsStart());
    if (id === "0") {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "api/report/DistWallertLoadV2Report"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: sessionStorage.getItem("userId"),
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata) {
          if (finaldata.data) {
            if (finaldata.data.errorCode === "200") {
              dispatch(getDMTReportsSuccess(finaldata.data));
            } else if (finaldata.data.errorCode === "404") {
              dispatch(getDMTReportsFail({ error: "Data not found!" }));
            } else {
              dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
            }
          } else {
            dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } catch (e) {
        dispatch(getDMTReportsFail(e));
      }
    } else {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "api/report/GetWalletloadV2ReportByDateAndUser"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: id,
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata) {
          if (finaldata.data) {
            if (finaldata.data.errorCode === "200") {
              dispatch(getDMTReportsSuccess(finaldata.data));
            } else if (finaldata.data.errorCode === "404") {
              dispatch(getDMTReportsFail({ error: "Data not found!" }));
            } else {
              dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
            }
          } else {
            dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } catch (e) {
        dispatch(getDMTReportsFail(e));
      }
    }
  };
};
export const getDistRetWalletLoadPGT2 = (date, id) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }

  return async (dispatch) => {
    dispatch(getDMTReportsStart());
    if (id === "0") {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "api/report/DistWallertLoadReportPGT2"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: sessionStorage.getItem("userId"),
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata) {
          if (finaldata.data) {
            if (finaldata.data.errorCode === "200") {
              dispatch(getDMTReportsSuccess(finaldata.data));
            } else if (finaldata.data.errorCode === "404") {
              dispatch(getDMTReportsFail({ error: "Data not found!" }));
            } else {
              dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
            }
          } else {
            dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } catch (e) {
        dispatch(getDMTReportsFail(e));
      }
    } else {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "api/report/DistWallertLoadReportPGT2"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: id,
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata) {
          if (finaldata.data) {
            if (finaldata.data.errorCode === "200") {
              dispatch(getDMTReportsSuccess(finaldata.data));
            } else if (finaldata.data.errorCode === "404") {
              dispatch(getDMTReportsFail({ error: "Data not found!" }));
            } else {
              dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
            }
          } else {
            dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } catch (e) {
        dispatch(getDMTReportsFail(e));
      }
    }
  };
};
export const getDistRetWalletLoadPGT3 = (date, id) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }

  return async (dispatch) => {
    dispatch(getDMTReportsStart());
    if (id === "0") {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "api/report/DistWallertLoadReportPGT3"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: sessionStorage.getItem("userId"),
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata) {
          if (finaldata.data) {
            if (finaldata.data.errorCode === "200") {
              dispatch(getDMTReportsSuccess(finaldata.data));
            } else if (finaldata.data.errorCode === "404") {
              dispatch(getDMTReportsFail({ error: "Data not found!" }));
            } else {
              dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
            }
          } else {
            dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } catch (e) {
        dispatch(getDMTReportsFail(e));
      }
    } else {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "api/report/DistWallertLoadReportPGT3"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: id,
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata) {
          if (finaldata.data) {
            if (finaldata.data.errorCode === "200") {
              dispatch(getDMTReportsSuccess(finaldata.data));
            } else if (finaldata.data.errorCode === "404") {
              dispatch(getDMTReportsFail({ error: "Data not found!" }));
            } else {
              dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
            }
          } else {
            dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } catch (e) {
        dispatch(getDMTReportsFail(e));
      }
    }
  };
};
export const getDistRetWalletLoadPGT4 = (date, id) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }

  return async (dispatch) => {
    dispatch(getDMTReportsStart());
    if (id === "0") {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "api/report/DistWallertLoadReportPGT4"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: sessionStorage.getItem("userId"),
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata) {
          if (finaldata.data) {
            if (finaldata.data.errorCode === "200") {
              dispatch(getDMTReportsSuccess(finaldata.data));
            } else if (finaldata.data.errorCode === "404") {
              dispatch(getDMTReportsFail({ error: "Data not found!" }));
            } else {
              dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
            }
          } else {
            dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } catch (e) {
        dispatch(getDMTReportsFail(e));
      }
    } else {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "api/report/DistWallertLoadReportPGT4"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: id,
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata) {
          if (finaldata.data) {
            if (finaldata.data.errorCode === "200") {
              dispatch(getDMTReportsSuccess(finaldata.data));
            } else if (finaldata.data.errorCode === "404") {
              dispatch(getDMTReportsFail({ error: "Data not found!" }));
            } else {
              dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
            }
          } else {
            dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } catch (e) {
        dispatch(getDMTReportsFail(e));
      }
    }
  };
};
export const getDistRetWalletLoadPGT5 = (date, id) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }

  return async (dispatch) => {
    dispatch(getDMTReportsStart());
    if (id === "0") {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "api/report/DistWallertLoadReportPGT5"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: sessionStorage.getItem("userId"),
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata) {
          if (finaldata.data) {
            if (finaldata.data.errorCode === "200") {
              dispatch(getDMTReportsSuccess(finaldata.data));
            } else if (finaldata.data.errorCode === "404") {
              dispatch(getDMTReportsFail({ error: "Data not found!" }));
            } else {
              dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
            }
          } else {
            dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } catch (e) {
        dispatch(getDMTReportsFail(e));
      }
    } else {
      try {
        const res = Api.apiCallPostFunction(
          "POST",
          `${
            process.env.REACT_APP_SITE_PRODUCTION_URL +
            "api/report/DistWallertLoadReportPGT5"
          }`,
          "application/x-www-form-urlencoded",
          {
            UserId: id,
            ...DateObj,
          }
        );

        const finaldata = await res;

        if (finaldata) {
          if (finaldata.data) {
            if (finaldata.data.errorCode === "200") {
              dispatch(getDMTReportsSuccess(finaldata.data));
            } else if (finaldata.data.errorCode === "404") {
              dispatch(getDMTReportsFail({ error: "Data not found!" }));
            } else {
              dispatch(getDMTReportsFail({ error: finaldata.data.msg }));
            }
          } else {
            dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
          }
        } else {
          dispatch(getDMTReportsFail({ error: "Some Error Occurred!" }));
        }
      } catch (e) {
        dispatch(getDMTReportsFail(e));
      }
    }
  };
};
//Aeps Transaction reports
const getAepsTransactionReportsStart = () => {
  return {
    type: actionTypes.GET_AEPS_TRANSACT_REPORTS_START,
  };
};

const getAepsTransactionReportsSuccess = (data) => {
  return {
    type: actionTypes.GET_AEPS_TRANSACT_REPORTS_SUCCESS,
    data,
  };
};

const getAepsTransactionReportsFail = (err) => {
  return {
    type: actionTypes.GET_AEPS_TRANSACT_REPORTS_FAIL,
    err,
  };
};

export const getAepsTransactionReports = (date) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }
  return async (dispatch) => {
    dispatch(getAepsTransactionReportsStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL +
          "/api/report/AepsTranReport"
        }`,
        "application/x-www-form-urlencoded",
        {
          UserId: sessionStorage.getItem("userId"),
          ...DateObj,
          RechargeType: date.RechargeType ? date.RechargeType : "",
        }
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(getAepsTransactionReportsSuccess(finaldata.data));
      } else if (finaldata.data.errorCode === "404") {
        dispatch(getAepsTransactionReportsFail({ error: "Data not found!" }));
      } else {
        dispatch(getAepsTransactionReportsFail({ error: finaldata.data.msg }));
      }
    } catch (e) {
      dispatch(getAepsTransactionReportsFail(e));
    }
  };
};

//Aeps Payout reports
const getAepsPayoutReportsStart = () => {
  return {
    type: actionTypes.GET_AEPS_PAYOUT_REPORTS_START,
  };
};

const getAepsPayoutReportsSuccess = (data) => {
  return {
    type: actionTypes.GET_AEPS_PAYOUT_REPORTS_SUCCESS,
    data,
  };
};

const getAepsPayoutReportsFail = (err) => {
  return {
    type: actionTypes.GET_AEPS_PAYOUT_REPORTS_FAIL,
    err,
  };
};

export const getAepsPayoutReports = (date) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }
  return async (dispatch) => {
    dispatch(getAepsPayoutReportsStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL +
          "/api/report/AepsPayoutReport"
        }`,
        "application/x-www-form-urlencoded",
        {
          UserId: sessionStorage.getItem("userId"),
          ...DateObj,
        }
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(getAepsPayoutReportsSuccess(finaldata.data));
      } else if (finaldata.data.errorCode === "404") {
        dispatch(getAepsPayoutReportsFail({ error: "Data not found!" }));
      }
    } catch (e) {
      dispatch(getAepsPayoutReportsFail(e));
    }
  };
};

//Recharge reports
const RechargeReportsStart = () => {
  return {
    type: actionTypes.RECHARGE_REPORTS_START,
  };
};

const RechargeReportsSuccess = (data) => {
  return {
    type: actionTypes.RECHARGE_REPORTS_SUCCESS,
    data,
  };
};

const RechargeReportsFail = (err) => {
  return {
    type: actionTypes.RECHARGE_REPORTS_FAIL,
    err,
  };
};

export const RechargeReports = (date, RechargeType) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }
  return async (dispatch) => {
    dispatch(RechargeReportsStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL +
          "/api/report/RechargeReport"
        }`,
        "application/x-www-form-urlencoded",
        {
          UserId: sessionStorage.getItem("userId"),
          ...DateObj,
          RechargeType: RechargeType,
        }
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(RechargeReportsSuccess(finaldata.data));
      } else if (finaldata.data.errorCode === "404") {
        dispatch(RechargeReportsFail({ error: "Data not found!" }));
      }
    } catch (e) {
      dispatch(RechargeReportsFail(e));
    }
  };
};

//Aeps ledger reports
const getAepsLedgerStart = () => {
  return {
    type: actionTypes.GET_AEPS_LEDGER_REPORTS_START,
  };
};

const getAepsLedgerSuccess = (data) => {
  return {
    type: actionTypes.GET_AEPS_LEDGER_REPORTS_SUCCESS,
    data,
  };
};

const getAepsLedgerFail = (err) => {
  return {
    type: actionTypes.GET_AEPS_LEDGER_REPORTS_FAIL,
    err,
  };
};

export const getAepsLedger = (date) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }

  return async (dispatch) => {
    dispatch(getAepsLedgerStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL + "/api/report/AepsLedger"
        }`,
        "application/x-www-form-urlencoded",
        {
          UserId: sessionStorage.getItem("userId"),
          ...DateObj,
        }
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(getAepsLedgerSuccess(finaldata.data));
      } else if (finaldata.data.errorCode === "404") {
        dispatch(getAepsLedgerFail({ error: "Data not found!" }));
      }
    } catch (e) {
      dispatch(getAepsLedgerFail(e));
    }
  };
};

//Scan And pay reports
const scanAndPayStart = () => {
  return {
    type: actionTypes.SCAN_AND_PAY_REPORTS_START,
  };
};

const scanAndPaySuccess = (data) => {
  return {
    type: actionTypes.SCAN_AND_PAY_REPORTS_SUCCESS,
    data,
  };
};

const scanAndPayFail = (err) => {
  return {
    type: actionTypes.SCAN_AND_PAY_REPORTS_FAIL,
    err,
  };
};

export const scanAndPay = (date) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }

  return async (dispatch) => {
    dispatch(scanAndPayStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL +
          "/api/report/ScanAndPayTranReport"
        }`,
        "application/x-www-form-urlencoded",
        {
          UserId: sessionStorage.getItem("userId"),
          ...DateObj,
        }
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(scanAndPaySuccess(finaldata.data));
      } else if (finaldata.data.errorCode === "404") {
        dispatch(scanAndPayFail({ error: "Data not found!" }));
      }
    } catch (e) {
      dispatch(scanAndPayFail(e));
    }
  };
};

//pay rent reports
const PayRentReportsStart = () => {
  return {
    type: actionTypes.PAY_RENT_REPORTS_START,
  };
};

const PayRentReportsSuccess = (data) => {
  return {
    type: actionTypes.PAY_RENT_REPORTS_SUCCESS,
    data,
  };
};

const PayRentReportsFail = (err) => {
  return {
    type: actionTypes.PAY_RENT_REPORTS_FAIL,
    err,
  };
};

export const PayRentReports = (date) => {
  let neWDate = new Date();
  let DateObj;
  if (date.FromDate === undefined) {
    const month = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    DateObj = {
      FromDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
      ToDate:
        neWDate.getFullYear() +
        "-" +
        month[neWDate.getMonth()] +
        "-" +
        neWDate.getDate(),
    };
  } else {
    DateObj = date;
  }
  return async (dispatch) => {
    dispatch(PayRentReportsStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL +
          "/api/report/GetPayrentReportById"
        }`,
        "application/x-www-form-urlencoded",
        {
          UserId: sessionStorage.getItem("userId"),
          ...DateObj,
        }
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(PayRentReportsSuccess(finaldata.data));
      } else if (finaldata.data.errorCode === "404") {
        dispatch(PayRentReportsFail({ error: "Data not found!" }));
      }
    } catch (e) {
      dispatch(PayRentReportsFail(e));
    }
  };
};
